export default {
  setCreditPacksData(state, creditPacks) {
    state.creditPacks = creditPacks;
  },
  setFreePlanCreditPacks(state, creditPacks) {
    state.creditPacks.freePlan = creditPacks;
  },
  setPaidPlanCreditPacks(state, creditPacks) {
    state.creditPacks.paidPlan = creditPacks;
  }
}
